import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { closePanel } from '../../../effects/closePanel';

export const onClose = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(closePanel());
    };
    return action;
};
